import "./App.css";

import { ErrorPopUp, LoadingBar } from "./components";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React, { useEffect } from "react";

import AdminCreate from "./pages/admin/AdminCreate";
import AdminDetail from "./pages/admin/AdminDetail";
import AdminList from "./pages/admin/AdminList";
import AdminUpdate from "./pages/admin/AdminUpdate";
import BannerCreate from "./pages/banner/BannerCreate";
import BannerList from "./pages/banner/BannerList";
import BannerUpdate from "./pages/banner/BannerUpdate";
import Campus from "./pages/campus/Campus";
import CampusBasicForm from "./pages/campus/CampusBasicForm";
import CampusHome from "./pages/campus/Index";
import CampusList from "./pages/campus/CampusList";
import CommodityCopy from "./pages/commodity/CommodityCopy";
import CommodityCreate from "./pages/commodity/CommodityCreate";
import CommodityMamagement from "./pages/commodity/CommodityManagement";
import CommodityProvision from "./pages/commodity/CommodityProvision";
import CommodityUpdate from "./pages/commodity/CommodityUpdate";
import CouponCreate from "./pages/coupon/CouponCreate";
import CouponDetail from "./pages/coupon/CouponDetail";
import CouponList from "./pages/coupon/CouponList";
import CouponUpdate from "./pages/coupon/CouponUpdate";
import DeungiChangeList from "./pages/deungiChange/DeungiChangeList";
import DeungiList from "./pages/deungi/DeungiList";
import DeungiNotice from "./pages/deungi/deungiNotice/Index";
import DeungiNoticeForm from "./pages/deungi/deungiNotice/DeungiNoticeForm";
import DeungiNoticeList from "./pages/deungi/deungiNotice/DeungiNoticeList";
import ExpertAdvertisementList from "./pages/expert/Advertisement/ExpertAdvertisementList";
import ExpertForm from "./pages/expert/ExpertForm";
import ExpertHome from "./pages/expert/ExpertHome";
import ExpertInquiryList from "./pages/expert/ExpertInquiryList";
import ExpertUserDetail from "./pages/expert/ExpertUserDetail";
import ExpertUserList from "./pages/expert/ExpertUserList";
import FAQForm from "./pages/help/FAQForm";
import FAQList from "./pages/help/FAQList";
import { Global } from "@emotion/react";
import Home from "./pages/home/Home";
import Layout from "./layout";
import Login from "./pages/login/Login";
import Logout from "./pages/login/Logout";
import Monitor from "./pages/monitor/Monitor";
import MyPage from "./pages/myPage/MyPage";
import NewsCreate from "./pages/news/NewsCreate";
import NewsList from "./pages/news/NewsList";
import NewsUpdate from "./pages/news/NewsUpdate";
import NoticeForm from "./pages/help/NoticeForm";
import NoticeList from "./pages/help/NoticeList";
import Partner from "./pages/Partner/Partner";
import PartnerBenefitsRegister from "./pages/Partner/Benefits/PartnerBenefitsRegister";
import PartnerDetail from "./pages/Partner/PartnerDetail";
import PartnerRegistration from "./pages/Partner/PartnerRegistration";
import PaymentCancel from "./pages/payment/PaymentCancel";
import PaymentExpert from "./pages/payment/PaymentExpert";
import PaymentList from "./pages/payment/PaymentList";
import PaymentSubscribe from "./pages/payment/PaymentSubscribe";
import ProductAuctionDetail from "./pages/product/ProductAuctionDetail";
import ProductList from "./pages/product/ProductList";
import ProductPublicDetail from "./pages/product/ProductPublicDetail";
import ProvisionCreate from "./pages/commodity/provision/ProvisionCreate";
import ProvisionUpdate from "./pages/commodity/provision/ProvisionUpdate";
import ProvisionView from "./pages/commodity/provision/ProvisionView";
import PushCreate from "./pages/notify/push/PushCreate";
import PushDetail from "./pages/notify/push/PushDetail";
import PushList from "./pages/notify/push/PushList";
import PushUpdate from "./pages/notify/push/PushUpdate";
import ReplyDetail from "./pages/help/containers/ReplyDetail";
import ReplyWaiting from "./pages/help/containers/ReplyWaiting";
import ResetPasswordPage from "./pages/login/ResetPasswordPage";
import RevenueList from "./pages/revenue/RevenueList";
import SMSList from "./pages/notify/SMSList";
import Settlement from "./pages/Partner/settlement";
import SituationCreate from "./pages/notify/situation/SituationCreate";
import SituationList from "./pages/notify/situation/SituationList";
import SituationUpdate from "./pages/notify/situation/SituationUpdate";
import Support from "./pages/help/SupportList";
import TemplateCreate from "./pages/notify/template/TemplateCreate";
import TemplateList from "./pages/notify/template/TemplateList";
import TemplateUpdate from "./pages/notify/template/TemplateUpdate";
import TestPage from "./pages/TestPage";
import UserBannerClickCount from "./pages/user/UserBannerClickCount";
import UserDetail from "./pages/user/UserDetail";
import UserList from "./pages/user/UserList";
import UserLotViewersList from "./pages/user/UserLotViewersList";
import UserUpdate from "./pages/user/UserUpdate";
import UserViewsCount from "./pages/user/UserViewsCountList";
import reset from "./styles/Reset";
import { storePathValue } from "./utils/store";
import { useDispatch, useSelector } from "react-redux";
import { endLoading } from "./reducers/loading";
import PartnerNewBenefits from "./pages/Partner/Benefits/PartnerNewBenefits";
import ExpertApprovalList from "./pages/expert/ExpertApprovalList";
import ExpertApprovalDetail from "./pages/expert/ExpertApprovalDetail";
import ExpertSettlementList from "./pages/expert/ExpertSettlementList";
import ExpertAgencyManage from "./pages/expert/ExpertAgencyManage";
import LecturesApply from "./pages/lectures/apply";
import LecturesCreate from "./pages/lectures/create";
import LecturesEdit from "./pages/lectures/edit";
import Lectures from "./pages/lectures";
import CommunityList from "./pages/community";
import CommunityDetail from "./pages/community/Detail";

function Router() {
    const isLoading = useSelector((state) => state.loading.isLoading);
    const isErrorPopUpShow = useSelector((state) => state.errorPopUp.isErrorPopUpShow);

    const dispatch = useDispatch();
    const location = useLocation();
    useEffect(() => {
        storePathValue();
        // 라우트가 바뀌면 이전 화면에서 켜진 로딩 상태를 초기화한다.
        dispatch(endLoading());
    }, [location, dispatch]);

    return (
        <>
            <Global styles={reset} />
            {isLoading && <LoadingBar />}
            {isErrorPopUpShow && <ErrorPopUp />}
            <Routes>
                <Route exact path="*" element={<Navigate replace to="/login" />} />
                <Route exact path="/login" element={<Login />} />
                <Route exact path="/resetPassword" element={<ResetPasswordPage />} />
                <Route exact path="/test" element={<TestPage />} />
                <Route path="/home" element={<Home />} />
                <Route path="/monitor" element={<Monitor />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/myPage" element={<Layout />}>
                    <Route path="list" element={<MyPage />} />
                </Route>
                <Route path="/business" element={<Layout />}>
                    <Route path="viewsCount" element={<UserViewsCount />} />
                    <Route path="lotViewsCount" element={<UserLotViewersList />} />
                    <Route path="bannerClickCount" element={<UserBannerClickCount />} />
                </Route>
                <Route path="/users" element={<Layout />}>
                    <Route path="list" element={<UserList />} />
                    <Route path="detail/:id" element={<UserDetail />} />
                    <Route path="update/:id" element={<UserUpdate />} />
                    <Route path="viewsCount" element={<UserViewsCount />} />
                    <Route path="lotViewsCount" element={<UserLotViewersList />} />
                </Route>
                <Route path="/experts" element={<Layout />}>
                    <Route path="home" element={<ExpertHome />} />
                    <Route path="register" element={<ExpertForm />} />
                    <Route path="update/:no" element={<ExpertForm />} />
                    <Route path="user/list" element={<ExpertUserList />} />
                    {/* <Route path="user/detail/:no" element={<ExpertUserDetail />} /> */}
                    <Route path="approval/list" element={<ExpertApprovalList />} />
                    <Route path="detail/:no" element={<ExpertApprovalDetail />} />
                    <Route path="advertisement/list" element={<ExpertAdvertisementList />} />
                    <Route path="inquiry/list" element={<ExpertInquiryList />} />
                    <Route path="settlement/list" element={<ExpertSettlementList />} />
                    <Route path="management" element={<ExpertAgencyManage />} />
                </Route>
                <Route path="/commodity" element={<Layout />}>
                    <Route path="list" element={<CommodityMamagement />} />
                    <Route path="provision" element={<CommodityProvision />} />
                    <Route path="create" element={<CommodityCreate />} />
                    <Route path="update/:id" element={<CommodityUpdate />} />
                    <Route path="copy/:id" element={<CommodityCopy />} />
                    <Route path="provision/create" element={<ProvisionCreate />} />
                    <Route path="provision/update/:id" element={<ProvisionUpdate />} />
                    <Route path="provision/view/:id" element={<ProvisionView />} />
                </Route>
                <Route path="/deungi" element={<Layout />}>
                    <Route path="list" element={<DeungiList />} />
                    <Route path="notice" element={<DeungiNotice />}>
                        <Route path="list" element={<DeungiNoticeList />} />
                        <Route path="create" element={<DeungiNoticeForm />} />
                        <Route path="update/:id" element={<DeungiNoticeForm />} />
                    </Route>
                </Route>
                <Route path="/payment" element={<Layout />}>
                    <Route path="list" element={<PaymentList />} />
                    <Route path="subscribe" element={<PaymentSubscribe />} />
                    <Route path="expert" element={<PaymentExpert />} />
                    <Route path="cancel" element={<PaymentCancel />} />
                </Route>
                <Route path="/revenue" element={<Layout />}>
                    <Route path="list" element={<RevenueList />} />
                </Route>
                <Route path="/products" element={<Layout />}>
                    <Route path="list" element={<ProductList />} />
                    <Route path="auction/:id" element={<ProductAuctionDetail />} />
                    <Route path="public/:id" element={<ProductPublicDetail />} />
                </Route>
                <Route path="/coupon" element={<Layout />}>
                    <Route path="list" element={<CouponList />} />
                    <Route path="create" element={<CouponCreate />} />
                    <Route path="detail/:id" element={<CouponDetail />} />
                    <Route path="update/:id" element={<CouponUpdate />} />
                </Route>
                <Route path="/banners" element={<Layout />}>
                    <Route path="list" element={<BannerList />} />
                    <Route path="create" element={<BannerCreate />} />
                    <Route path="update/:id" element={<BannerUpdate />} />
                </Route>
                <Route path="/news" element={<Layout />}>
                    <Route path="list" element={<NewsList />} />
                    <Route path="create" element={<NewsCreate />} />
                    <Route path="update/:id" element={<NewsUpdate />} />
                </Route>
                <Route path="/notify" element={<Layout />}>
                    <Route path="sms" element={<SMSList />} />
                    <Route path="push" element={<PushList />} />
                    <Route path="push/create" element={<PushCreate />} />
                    <Route path="push/update/:id" element={<PushUpdate isUpdate={true} />} />
                    <Route path="push/detail/:id" element={<PushDetail />} />
                    <Route path="template" element={<TemplateList />} />
                    <Route path="template/create" element={<TemplateCreate />} />
                    <Route path="template/update/:id" element={<TemplateUpdate />} />
                    <Route path="template/detail/:id" element={<TemplateUpdate isDetail={true} />} />
                    <Route path="situation" element={<SituationList />} />
                    <Route path="situation/create" element={<SituationCreate />} />
                    <Route path="situation/update/:id" element={<SituationUpdate />} />
                    <Route path="situation/detail/:id" element={<SituationUpdate isDetail={true} />} />
                </Route>
                <Route path="/help" element={<Layout />}>
                    <Route path="support" element={<Support />} />
                    <Route path="support/reply/:id" element={<ReplyWaiting />} />
                    <Route path="support/detail/:id" element={<ReplyDetail />} />
                    <Route path="faq" element={<FAQList />} />
                    <Route path="faq/create" element={<FAQForm />} />
                    <Route path="faq/update/:id" element={<FAQForm isUpdate={true} />} />
                    <Route path="notice" element={<NoticeList />} />
                    <Route path="notice/create" element={<NoticeForm />} />
                    <Route path="notice/update/:id" element={<NoticeForm isUpdate={true} />} />
                </Route>
                <Route path="/admins" element={<Layout />}>
                    <Route path="list" element={<AdminList />} />
                    <Route path="detail/:id" element={<AdminDetail />} />
                    <Route path="create" element={<AdminCreate />} />
                    <Route path="update/:id" element={<AdminUpdate />} />
                </Route>
                <Route path="/campus" element={<Layout />}>
                    <Route path="management" element={<CampusHome />}>
                        <Route path="lectures" element={<CampusList />} />
                        <Route path="lecture/:id" element={<Campus />} />
                        <Route path="create" element={<CampusBasicForm />} />
                        <Route path="update/:id" element={<CampusBasicForm />} />
                    </Route>
                </Route>
                <Route path="/community" element={<Layout />}>
                        <Route path="list" element={<CommunityList />} />
                        <Route path="detail/:id" element={<CommunityDetail />} />
                </Route>
                <Route path="/offline" element={<Layout />}>
                    <Route path="lectures" element={<Lectures />} />
                    <Route path="create" element={<LecturesCreate />} />
                    <Route path="edit/:id" element={<LecturesEdit />} />
                    <Route path="apply/:id" element={<LecturesApply />} />
                </Route>
                <Route path="/partner" element={<Layout />}>
                    <Route path="list" element={<Partner />} />
                    <Route path="register" element={<PartnerRegistration />} />
                    <Route path="detail/:no" element={<PartnerDetail />} />
                    <Route path="update/:no" element={<PartnerRegistration />} />
                    {/* <Route path="benefits" element={<PartnerBenefits />} /> */}
                    <Route path="benefits" element={<PartnerNewBenefits />} />
                    <Route path="benefits/register" element={<PartnerBenefitsRegister />} />
                    <Route path="settlement" element={<Settlement />} />
                </Route>
                <Route path="/deungiChange" element={<Layout />}>
                    <Route path="list" element={<DeungiChangeList />} />
                </Route>
            </Routes>
        </>
    );
}

export default Router;
